ModelCache = require 'db/model-cache'
rpc = require 'network/rpc'
assert = require 'lib/assert'
_ = require 'underscore'

assocAt = (root, keyPath, newValue) ->
  assert keyPath.length >= 1
  [key, remainingKeys...] = keyPath

  newObj = if root? then _.clone(root) else {}
  newObj[key] = if remainingKeys.length == 0
    newValue
  else
    assocAt newObj[key], remainingKeys, newValue

  return newObj

# Currently, when someone edits a comment, the server will send the action's
# updated 'data' map but will not send its updated 'display' map.
#
# Since 'display' is the only thing we look at when we're rendering an action,
# deltas for comment edits don't actually mean anything to us.
#
# So here we massage the delta into what we *hope* it *one day* looks like,
# with an updated 'display' map.
#
# If the server ever starts sending 'display', please delete all of this
# code. See https://trello.com/c/HE9siIlh for the server report.
transformDeltaForAction = (delta) ->
  if delta.display?
    return delta
  if !(action = ModelCache.get('Action', delta.id))?
    return delta
  if action.get('type') != 'commentCard'
    return delta
  newComment = delta.data?.text
  if !newComment?
    return delta

  delta = _.clone(delta)
  delta.display = assocAt action.get('display'), ['entities', 'comment', 'text'], newComment
  return delta

normalizeId = (delta) ->
  if !delta._id?
    return delta
  delta = _.clone(delta)
  delta.id ?= delta._id
  delete delta._id
  delta

rpc.on 'updateModels', ({ typeName, deltas }) ->
  deltas = deltas.map(normalizeId)
  if typeName == 'Action'
    deltas = deltas.map(transformDeltaForAction)
  for delta in deltas
    ModelCache.enqueueDelta(typeName, delta)
  return

rpc.on 'deleteModels', ({ typeName, deltas }) ->
  for { id } in deltas.map(normalizeId)
    ModelCache.enqueueDelta(typeName, { id, deleted: true })
  return



// WEBPACK FOOTER //
// ./app/scripts/entry/live-updater.coffee